import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import Cookies from "js-cookie";
import { Dropdown } from "react-bootstrap";
import { BsPersonFill } from "react-icons/bs";
import { FaGooglePlay } from "react-icons/fa";
import { useEffect, useState } from "react";
import { useLocation } from "react-router";

function Header({ loggedIn, setLoggedIn }) {
  const location = useLocation();
  const [isAndroidApp, setIsAndroidApp] = useState(false);
  
  // Derive isLoggedIn from token
  const isLoggedIn = !!Cookies.get("token");
  
  useEffect(() => {
    const token = Cookies.get("token");
    if (token) {
      setLoggedIn(loggedIn);
    } else {
      setLoggedIn(false);
    }
    // console.log("useeffect is working at this point");
    
    // Check if user agent indicates Android app
    const userAgent = navigator.userAgent || "";
    const isAndroidApp = /MyHostelDuniyaApp/i.test(userAgent);
    setIsAndroidApp(isAndroidApp);
  }, [loggedIn, setLoggedIn]);

  const isActive = (path) => {
    if (path === "/") {
      return location.pathname === "/";
    }
    return location.pathname.startsWith(path);
  };
  return (
    <Navbar
      expand="lg"
      className="bg-white text-start sticky-top shadow-sm custom-navbar"
      style={{
        borderBottom: "2px solid #f0f0f0",
        padding: "0.75rem 0",
      }}
    >
      <Container className="header-container">
        <Navbar.Brand href="/" className="d-flex align-items-center header-logo">
          <img
            src={`${process.env.PUBLIC_URL}/hosteladminlogo.png`}
            style={{ height: "50px", transition: "transform 0.3s ease" }}
            onMouseEnter={(e) => e.currentTarget.style.transform = "scale(1.05)"}
            onMouseLeave={(e) => e.currentTarget.style.transform = "scale(1)"}
            alt="Hostel Duniya Logo"
          />
        </Navbar.Brand>
        {Cookies.get("token") && (
          <Navbar.Toggle 
            aria-controls="basic-navbar-nav" 
            className="custom-navbar-toggle"
            aria-label="Toggle navigation"
          />
        )}

        {Cookies.get("token") && (
          <Navbar.Collapse id="basic-navbar-nav" className="custom-navbar-collapse">
            <Nav className="me-auto custom-nav">
              <Nav.Link
                href="/"
                className="fw-semibold mx-2 custom-nav-link"
                style={{
                  color: isActive("/") ? "#8B0000" : "#333",
                  fontSize: "16px",
                  transition: "all 0.3s ease",
                  borderRadius: isActive("/") ? "8px 8px 0 0" : "8px",
                  padding: "8px 16px",
                  backgroundColor: isActive("/") ? "#fff5f5" : "transparent",
                  borderBottom: isActive("/") ? "3px solid #8B0000" : "3px solid transparent",
                  fontWeight: isActive("/") ? "700" : "600",
                }}
                onMouseEnter={(e) => {
                  if (!isActive("/")) {
                    e.target.style.color = "#8B0000";
                    e.target.style.backgroundColor = "#f8f8f8";
                  }
                }}
                onMouseLeave={(e) => {
                  if (!isActive("/")) {
                    e.target.style.color = "#333";
                    e.target.style.backgroundColor = "transparent";
                  }
                }}
              >
                Dashboard
              </Nav.Link>
              <Nav.Link
                href="/hostel/list"
                className="fw-semibold mx-2 custom-nav-link"
                style={{
                  color: isActive("/hostel") ? "#8B0000" : "#333",
                  fontSize: "16px",
                  transition: "all 0.3s ease",
                  borderRadius: isActive("/hostel") ? "8px 8px 0 0" : "8px",
                  padding: "8px 16px",
                  backgroundColor: isActive("/hostel") ? "#fff5f5" : "transparent",
                  borderBottom: isActive("/hostel") ? "3px solid #8B0000" : "3px solid transparent",
                  fontWeight: isActive("/hostel") ? "700" : "600",
                }}
                onMouseEnter={(e) => {
                  if (!isActive("/hostel")) {
                    e.target.style.color = "#8B0000";
                    e.target.style.backgroundColor = "#f8f8f8";
                  }
                }}
                onMouseLeave={(e) => {
                  if (!isActive("/hostel")) {
                    e.target.style.color = "#333";
                    e.target.style.backgroundColor = "transparent";
                  }
                }}
              >
                My Hostels
              </Nav.Link>
              <Nav.Link
                href="/leads"
                className="fw-semibold mx-2 custom-nav-link"
                style={{
                  color: isActive("/leads") ? "#8B0000" : "#333",
                  fontSize: "16px",
                  transition: "all 0.3s ease",
                  borderRadius: isActive("/leads") ? "8px 8px 0 0" : "8px",
                  padding: "8px 16px",
                  backgroundColor: isActive("/leads") ? "#fff5f5" : "transparent",
                  borderBottom: isActive("/leads") ? "3px solid #8B0000" : "3px solid transparent",
                  fontWeight: isActive("/leads") ? "700" : "600",
                }}
                onMouseEnter={(e) => {
                  if (!isActive("/leads")) {
                    e.target.style.color = "#8B0000";
                    e.target.style.backgroundColor = "#f8f8f8";
                  }
                }}
                onMouseLeave={(e) => {
                  if (!isActive("/leads")) {
                    e.target.style.color = "#333";
                    e.target.style.backgroundColor = "transparent";
                  }
                }}
              >
                Leads
              </Nav.Link>
              <Nav.Link
                href="/contact-us"
                className="fw-semibold mx-2 custom-nav-link"
                style={{
                  color: isActive("/contact-us") ? "#8B0000" : "#333",
                  fontSize: "16px",
                  transition: "all 0.3s ease",
                  borderRadius: isActive("/contact-us") ? "8px 8px 0 0" : "8px",
                  padding: "8px 16px",
                  backgroundColor: isActive("/contact-us") ? "#fff5f5" : "transparent",
                  borderBottom: isActive("/contact-us") ? "3px solid #8B0000" : "3px solid transparent",
                  fontWeight: isActive("/contact-us") ? "700" : "600",
                }}
                onMouseEnter={(e) => {
                  if (!isActive("/contact-us")) {
                    e.target.style.color = "#8B0000";
                    e.target.style.backgroundColor = "#f8f8f8";
                  }
                }}
                onMouseLeave={(e) => {
                  if (!isActive("/contact-us")) {
                    e.target.style.color = "#333";
                    e.target.style.backgroundColor = "transparent";
                  }
                }}
              >
                Support
              </Nav.Link>
              {isLoggedIn && (
                <Nav.Link
                  href="/profile"
                  className="fw-semibold d-lg-none d-block mx-2 custom-nav-link custom-mobile-link"
                  style={{
                    color: "#333",
                    fontSize: "16px",
                    transition: "color 0.3s ease",
                    borderRadius: "8px",
                    padding: "8px 16px",
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.color = "#8B0000";
                    e.target.style.backgroundColor = "#f8f8f8";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.color = "#333";
                    e.target.style.backgroundColor = "transparent";
                  }}
                >
                  Profile
                </Nav.Link>
              )}
              {isLoggedIn && (
                <Nav.Link
                  href="/login"
                  className="fw-semibold d-lg-none d-block mx-2 custom-nav-link custom-mobile-link custom-logout-link"
                  onClick={() => Cookies.remove("token")}
                  style={{
                    color: "#8B0000",
                    fontSize: "16px",
                    transition: "color 0.3s ease",
                    borderRadius: "8px",
                    padding: "8px 16px",
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.color = "#A00000";
                    e.target.style.backgroundColor = "#f8f8f8";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.color = "#8B0000";
                    e.target.style.backgroundColor = "transparent";
                  }}
                >
                  Logout
                </Nav.Link>
              )}
              {!isAndroidApp && (
                <a
                  href="https://play.google.com/store/apps/details?id=com.hostelduniya.associate&pcampaignid=web_share"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="fw-semibold d-lg-none d-block mx-2 custom-nav-link custom-mobile-link"
                  style={{
                    backgroundColor: "#8B0000",
                    color: "white",
                    fontSize: "16px",
                    transition: "all 0.3s ease",
                    borderRadius: "8px",
                    padding: "8px 16px",
                    textDecoration: "none",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    boxShadow: "0 4px 15px rgba(139, 0, 0, 0.3)",
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = "#A00000";
                    e.target.style.transform = "translateY(-2px)";
                    e.target.style.boxShadow = "0 6px 20px rgba(139, 0, 0, 0.4)";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = "#8B0000";
                    e.target.style.transform = "translateY(0)";
                    e.target.style.boxShadow = "0 4px 15px rgba(139, 0, 0, 0.3)";
                  }}
                >
                  <FaGooglePlay className="me-2" />
                  Download App
                </a>
              )}
            </Nav>
          </Navbar.Collapse>
        )}

        {Cookies.get("token") && (
          <Nav className="d-none d-lg-flex align-items-center" id="hidethis">
            {!isAndroidApp && (
              <a
                href="https://play.google.com/store/apps/details?id=com.hostelduniya.associate&pcampaignid=web_share"
                target="_blank"
                rel="noopener noreferrer"
                className="d-flex align-items-center justify-content-center fw-semibold"
                style={{
                  backgroundColor: "#8B0000",
                  color: "white",
                  borderRadius: "10px",
                  padding: "8px 16px",
                  fontSize: "14px",
                  transition: "all 0.3s ease",
                  textDecoration: "none",
                  boxShadow: "0 4px 15px rgba(139, 0, 0, 0.3)",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = "#A00000";
                  e.currentTarget.style.transform = "translateY(-2px)";
                  e.currentTarget.style.boxShadow = "0 6px 20px rgba(139, 0, 0, 0.4)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = "#8B0000";
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "0 4px 15px rgba(139, 0, 0, 0.3)";
                }}
              >
                <FaGooglePlay className="me-2" />
                Download App
              </a>
            )}
            <Dropdown className="ms-3">
              <Dropdown.Toggle
                variant="outline-danger"
                id="dropdown-basic"
                style={{
                  borderColor: "#8B0000",
                  color: "#8B0000",
                  borderRadius: "10px",
                  padding: "8px 16px",
                  transition: "all 0.3s ease",
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = "#8B0000";
                  e.target.style.color = "white";
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = "transparent";
                  e.target.style.color = "#8B0000";
                }}
              >
                <BsPersonFill className="me-2" />
                Profile
              </Dropdown.Toggle>
              <Dropdown.Menu
                style={{
                  borderRadius: "10px",
                  border: "none",
                  boxShadow: "0 5px 20px rgba(0,0,0,0.1)",
                  marginTop: "10px",
                }}
              >
                <Dropdown.Item
                  href="/profile"
                  style={{
                    padding: "10px 20px",
                    transition: "background-color 0.3s ease",
                  }}
                  onMouseEnter={(e) => (e.target.style.backgroundColor = "#f8f8f8")}
                  onMouseLeave={(e) => (e.target.style.backgroundColor = "transparent")}
                >
                  Profile
                </Dropdown.Item>
                <Dropdown.Item
                  href="/login"
                  onClick={() => Cookies.remove("token")}
                  style={{
                    padding: "10px 20px",
                    color: "#8B0000",
                    transition: "background-color 0.3s ease",
                  }}
                  onMouseEnter={(e) => (e.target.style.backgroundColor = "#fff5f5")}
                  onMouseLeave={(e) => (e.target.style.backgroundColor = "transparent")}
                >
                  Logout
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
            <div
              className="ms-3 d-flex align-items-center justify-content-center"
              role="button"
              tabIndex={0}
              style={{
                width: "40px",
                height: "40px",
                borderRadius: "50%",
                border: "2px solid #e0e0e0",
                backgroundColor: "white",
                transition: "all 0.3s ease",
                cursor: "pointer",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.borderColor = "#8B0000";
                e.currentTarget.style.backgroundColor = "#f8f8f8";
                e.currentTarget.style.transform = "scale(1.1)";
                e.currentTarget.style.boxShadow = "0 4px 12px rgba(0,0,0,0.15)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.borderColor = "#e0e0e0";
                e.currentTarget.style.backgroundColor = "white";
                e.currentTarget.style.transform = "scale(1)";
                e.currentTarget.style.boxShadow = "none";
              }}
            >
              <img
                src={`${process.env.PUBLIC_URL}/india-logo.jpg`}
                style={{ width: "26px", height: "26px", objectFit: "cover", borderRadius: "50%" }}
                alt="India"
              />
            </div>
          </Nav>
        )}
        {!Cookies.get("token") && (
          <Nav className="d-none d-lg-flex align-items-center">
            {!isAndroidApp && (
              <a
                href="https://play.google.com/store/apps/details?id=com.hostelduniya.associate&pcampaignid=web_share"
                target="_blank"
                rel="noopener noreferrer"
                className="d-flex align-items-center justify-content-center fw-semibold"
                style={{
                  backgroundColor: "#8B0000",
                  color: "white",
                  borderRadius: "10px",
                  padding: "8px 16px",
                  fontSize: "14px",
                  transition: "all 0.3s ease",
                  textDecoration: "none",
                  boxShadow: "0 4px 15px rgba(139, 0, 0, 0.3)",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = "#A00000";
                  e.currentTarget.style.transform = "translateY(-2px)";
                  e.currentTarget.style.boxShadow = "0 6px 20px rgba(139, 0, 0, 0.4)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = "#8B0000";
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "0 4px 15px rgba(139, 0, 0, 0.3)";
                }}
              >
                <FaGooglePlay className="me-2" />
                Download App
              </a>
            )}
            <div
              className="ms-3 d-flex align-items-center justify-content-center"
              role="button"
              tabIndex={0}
              style={{
                width: "40px",
                height: "40px",
                borderRadius: "50%",
                border: "2px solid #e0e0e0",
                backgroundColor: "white",
                transition: "all 0.3s ease",
                cursor: "pointer",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.borderColor = "#8B0000";
                e.currentTarget.style.backgroundColor = "#f8f8f8";
                e.currentTarget.style.transform = "scale(1.1)";
                e.currentTarget.style.boxShadow = "0 4px 12px rgba(0,0,0,0.15)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.borderColor = "#e0e0e0";
                e.currentTarget.style.backgroundColor = "white";
                e.currentTarget.style.transform = "scale(1)";
                e.currentTarget.style.boxShadow = "none";
              }}
            >
              <img
                src={`${process.env.PUBLIC_URL}/india-logo.jpg`}
                style={{ width: "26px", height: "26px", objectFit: "cover", borderRadius: "50%" }}
                alt="India"
              />
            </div>
          </Nav>
        )}
      </Container>
    </Navbar>
  );
}

export default Header;
